// Library
import MicroModal from 'micromodal';

// Funtion
import adjustViewport from './function/adjustViewport'

// Module
import SmoothScroll from './module/SmoothScroll';
import Modal from './module/Modal';
import FaqAccordion from './module/FaqAccordion';
import Slider from './module/Slider';

const init = () => {

  (() => {
    const smoothScroll = new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
    smoothScroll.init();
  })();

  (() => {
    // const headerDrawerMenu = new Modal({
    //   modalId: 'js-drawer-menu',
    //   toggleBtn: '#js-drawer-menu-toggle-btn',
    //   openButtons: '',
    //   closeButtons: '[data-drawer-menu-close-btn]',
    //   container: '#js-drawer-menu-container',
    // });
    // headerDrawerMenu.init();
    MicroModal.init({
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      // openClass: 'is-active',
    });
  })();

  (() => {
    const faqAccordion = new FaqAccordion();
    faqAccordion.init();
  })();

  (() => {
    const slider = new Slider();
    slider.init();
  })();

};

window.addEventListener('DOMContentLoaded', () => {
  // adjustViewport();
  init();
});